import { createContext as t, useContext as o } from "react";
import { a as e } from "../../../vanilla-CSAfDK5R.js";
const r = () => ({
  modeAtom: e("dark")
}), a = t(r()), n = () => o(a);
export {
  a as FooterContext,
  r as createFooterState,
  n as useFooterStateAtoms
};
//# sourceMappingURL=index.js.map
